import { jsx as _jsx } from "react/jsx-runtime";
import { useWorld } from "./world.js";
import { statLook } from "./stat-look.js";
export function StatIcon({ statId, size = 14, title, }) {
    const world = useWorld();
    const look = statLook(world.snapshot, statId);
    const url = look.iconPath === undefined ? null : world.icon(look.iconPath);
    if (url === null) {
        return (_jsx("span", { className: "stat-icon glyph", style: { width: size, height: size, color: look.colour, fontSize: size - 2 }, title: title, children: look.glyph }));
    }
    return (_jsx("img", { className: "stat-icon", src: url, width: size, height: size, alt: "", title: title, draggable: false }));
}
/**
 * Any texture the pack ships, by resource path.
 *
 * For the icons that are not a stat's: the tab strip, a section heading, a spell school. Renders
 * nothing at all when the path did not extract, because these sit beside a word that already
 * says what the thing is — an empty square next to "Damage" is worse than no square.
 */
export function PackIcon({ path, size = 14, title, }) {
    const world = useWorld();
    const url = world.icon(path);
    if (url === null)
        return null;
    return (_jsx("img", { className: "stat-icon", src: url, width: size, height: size, alt: "", title: title, draggable: false }));
}
/**
 * The colour a stat's own numbers are printed in.
 *
 * Exported beside the icon because the two always travel together — an icon that is fire red
 * over a value that is default grey is worse than either alone.
 */
export function useStatColour(statId) {
    const world = useWorld();
    return statLook(world.snapshot, statId).colour;
}
//# sourceMappingURL=StatIcon.js.map